export default { sha: '70035123fa7fa0b7b7ec8d15e2f1249c2bdcc4d3', buildNumber: 'undefined' }
